import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import { Link } from "react-router-dom";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SinglePostInteraction from "./SinglePostInteraction";
import SinglePostComment from "./SinglePostComment";
import SinglePostEngagement from "./SinglePostEngagement";
import { header, post } from "../../config/imagesLink";
import LikesDetails from "./LikesDetails";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import PostVideoCommon from "../PersonalProfile/PostVideoCommon";
import useLocalStorage from "use-local-storage";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { Token } from "@mui/icons-material";
import PostComponent from "./PostComponent";
import { useTranslation } from "react-i18next";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';

import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from "@mui/material";

const ImageSliderModal = ({ 
  setIspostmodalOpen,
  ispostmodalOpen,
  onRequestClose,
  isOpen,
  singlepostId,
  isLoading,
  setIsfollowedComp,
  isfollowedComp,
  setIsLiked,
  isLiked,
  updateCommentCount,
  prevComments,
  AllPostListNews,
  updateCommentLike,
  setSinglePostId,
  setSinglePostContent,
  dLike,
  openModal,
  updateLikeCount,
  setDLike,
  isfollowed,
  setIsfollowed,
  sliderSettings,
  initialSlideIndex,
  setInitialSlideIndex,
  imageArray,
  setPostList,
  setIsLoading,
  postList,
  updatePostLike,
  updateReplyCommentLike,
}) => {
  const guestModeData = localStorage.getItem("guestMode");
  const [isDark, setIsDark] = useLocalStorage('isDark', false);
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const visibleVideoRef = useRef(null);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const localeMap = {
    en: "en",
    ar: "ar",
    hi: "hi",
  };

  const locale = localeMap[language] || "en";
  const [singlepostList, setSinglePostList] = useState("");
  const [singlepostListinfo, setSinglePostListInfo] = useState("");
  const [singlepostCommentList, setSinglePostCommentList] = useState([]);
  const iframeRef = useRef(null);

  const AllPostData = async () => {
    try {
      await axios
        .get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${singlepostId}&RestrictedViewerToken=${restrictedViewerTokens}&langKey=${language}`)
        .then((resData) => {
          setSinglePostList(resData.data.responseData);
          setSinglePostListInfo(resData.data.responseData.postInfo);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const AllPostComments = () => {
    try {
      axios
        .get(`/Posts/LoadAllComments?DeviceType=Web&PostId=${singlepostId}&langKey=${language}`)
        .then((resData) => {
          setSinglePostCommentList(resData.data.responseData);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const AllPostList = async () => (
    AllPostData(),
    AllPostComments()
  )

  console.log("singlepostListinfo==>", singlepostListinfo)
  useEffect(() => {
    AllPostList();
    // AllPostComments();
  }, [singlepostId]);

  const settings = {
    dots: false,
    arrows: singlepostList?.postInfo?.mediaFilesList?.length > 1,
    infinite: singlepostList?.postInfo?.mediaFilesList?.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [showModal, setShowModal] = useState(false);
  const [postLikedType, setPostLikedType] = useState(false);
  const [postId, setPostId] = useState("");
  const [expandedPosts, setExpandedPosts] = useState({});
  const [postContentMap, setPostContentMap] = useState({});

  const handleShowModal = (item) => {
    setPostId(item.postId);
    setPostLikedType(item.likedType);
    setShowModal(true);
  };

  const handleLikesCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isOpen) {
        if (e.key === "ArrowLeft") {
          document.querySelector(".slick-prev").click();
        } else if (e.key === "ArrowRight") {
          document.querySelector(".slick-next").click();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  // Hide body scroll when modal is open using a CSS class
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('imageslider-modal-open');
    } else {
      document.body.classList.remove('imageslider-modal-open');
    }
    
    return () => {
      document.body.classList.remove('imageslider-modal-open');
    };
  }, [isOpen]);

  const [loading, setLoading] = useState(true); // State for loading status
  // Function to handle image loading
  const handleImageLoad = () => {
    setLoading(false); // Set loading to false when image is fully loaded
  };


  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${item.entityID || item?.entity}" class="user-mention">@${item.displayName || item?.display}</a>`
          : item.type === "Hashtag"
            ? `<a href="/hashtag/${item.displayName || item?.display}" class="hashtag">#${item.displayName || item?.display}</a>`
            : item.type === "CompanyMention"
              ? `<a href="/Company/${item.entityID || item?.entity}" class="user-mention">@${item.displayName || item?.display}</a>`
              : item.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

  const processExpandedContent = (expandedContent, fallbackDynamicValues = []) => {
    let resolvedContent = expandedContent;
    let resolvedDynamicValues = fallbackDynamicValues;

    if (expandedContent && typeof expandedContent === "object") {
      resolvedContent =
        expandedContent?.postContent ||
        expandedContent?.mainContent ||
        expandedContent?.content ||
        expandedContent?.postMainContent ||
        "";

      if (Array.isArray(expandedContent?.dynamicValues) && expandedContent.dynamicValues.length) {
        resolvedDynamicValues = expandedContent.dynamicValues;
      }
    }

    const withDynamicValues = replaceDynamicValues(
      resolvedContent || "",
      resolvedDynamicValues || []
    );

    const cleanedContent = withDynamicValues.replace(/\{\d+\}/g, "");

    return linkifyContent(addTargetBlankToAnchors(cleanedContent));
  };

  const readMore = async (id) => {
    try {
      if (postContentMap[id]) {
        setExpandedPosts((prev) => ({ ...prev, [id]: true }));
        return;
      }

      const res = await axios.get(
        `/Posts/GetPostMainContent?DeviceType=Web&PostId=${id}&langKey=${language}`
      );

      setPostContentMap((prev) => ({
        ...prev,
        [id]: res.data.responseData,
      }));

      setExpandedPosts((prev) => ({
        ...prev,
        [id]: true,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const formattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        singlepostListinfo?.postInfo?.postContent,
        singlepostListinfo?.postInfo?.dynamicValues
      )
    )
  );

  const sharedPostFormattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        singlepostListinfo?.postInfo?.sharedPost?.postContent,
        singlepostListinfo?.postInfo?.sharedPost?.dynamicValues
      )
    )
  );

  useEffect(() => {
    if (isOpen && singlepostListinfo?.postInfo) {
      setIsLoading(false); // Modal open and post info is loaded
    }
  }, [isOpen, singlepostListinfo]);

  const reloadVideo = () => {
    // console.log("hiiiiiiiiiiiiiiii");

    const iframe = iframeRef.current;
    if (iframe) {
      // Force reload by resetting src
      const originalSrc = iframe.src;
      iframe.src = '';
      setTimeout(() => {
        iframe.src = originalSrc;
      }, 100); // small delay ensures reload
    }
  };

  const videoRef = useRef(null);
  // const sharedVideoRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const videoId = singlepostListinfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
    // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
    const region = "centralindia";

    console.log("videoId:", videoId);
    // console.log("token:", restrictedViewerToken);

    if (!videoId || !restrictedViewerTokens || !videoRef.current) {
      console.error("Missing videoId or token or ref.");
      return;
    }

    const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerTokens });
    // console.log("manifestUrl:", manifestUrl);
    let hls;
    let plyrInstance;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("Manifest parsed");
        plyrInstance = new Plyr(videoRef.current, {
          captions: { active: true, update: true, language: "en" },
        });

        // Wait for a short time, then try to play
        videoRef.muted = true; // always start muted
        videoRef.current?.play().catch(err => {
          console.warn("Play interrupted", err);
        });

      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js Error:", data);
      });
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      console.log(" Native HLS fallback");
      videoRef.current.src = manifestUrl;
      // plyrInstance = new Plyr(videoRef.current);
      videoRef.current.addEventListener("loadedmetadata", () => {
        videoRef.current?.play();
      });
    }
    return () => {
      // if (plyrInstance) plyrInstance.destroy();
      if (hls) hls.destroy();
    };
  }, [ispostmodalOpen, restrictedViewerTokens]);


  const shouldShowModal =
    isOpen && singlepostListinfo?.cntntTypCategory && singlepostListinfo?.postInfo;

  console.log("singadhfsdas", singlepostListinfo);

  const getRelativeTime = (singlepostListinfo) => {
    const now = moment.utc().local();
    const itemTime = moment
      .utc(singlepostListinfo?.postInfo?.creationTime)
      .local();

    const diffSeconds = now.diff(itemTime, "seconds");
    const diffMinutes = now.diff(itemTime, "minutes");
    const diffHours = now.diff(itemTime, "hours");
    const diffDays = now.diff(itemTime, "days");
    const diffMonths = now.diff(itemTime, "months", true);
    const diffYears = now.diff(itemTime, "years", true);

    /* JUST NOW */
    if (diffSeconds < 60) {
      return t("Notifications.Just Now");
    }

    /* MINUTES */
    if (diffMinutes < 60) {
      return diffMinutes === 1
        ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
        : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
    }

    /* HOURS */
    if (diffHours < 24) {
      return diffHours === 1
        ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
        : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
    }

    /* DAYS */
    if (diffDays < 30) {
      return diffDays === 1
        ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
        : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
    }

    /* MONTHS */
    if (diffMonths < 12) {
      const displayMonth =
        diffMonths >= 0.75 && diffMonths < 1.25
          ? 1
          : Math.round(diffMonths * 2) / 2;

      return displayMonth === 1
        ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
        : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
    }

    /* YEARS */
    const displayYear =
      diffYears >= 0.75 && diffYears < 1.25
        ? 1
        : Math.round(diffYears * 2) / 2;

    return displayYear === 1
      ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
      : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
  };


  return (
    <>


      {/* {console.log("singlepostListinfo", singlepostListinfo)} */}

      {/* {isOpen && ( */}
      <div
        className={`${singlepostListinfo?.cntntTypCategory === "Text" ? "modal-md" : "modal-xl"
          } modal fade show postAdd`}
        // className={`
        //   ${Array.isArray(singlepostListinfo?.postInfo?.mediaFilesList) ||
        //   singlepostListinfo?.postInfo?.mediaFilesList?.length === 0
        //   ? "modal-xl"
        //   : "modal-md"
        //   } modal fade show postAdd`}
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-dialog-centered m-auto"
          role="document"
          style={{ height: "100vh" }}
        >
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{t("modals.Loading")}</span>
              </div>
            </div>
          ) : (
            <>
              <div
                className="modal-content ImagesliderScroller d-flex m-auto MobileCommentmodal"
                style={{ overflowY: "auto", height: "100vh" }}
              >
                <div className="modalBorder d-flex justify-content-between align-items-center p-3">
                  {isDark ? (
                    <div className="Logo">
                      <img src={header.whiteoglogo} alt="" width={130} />
                    </div>
                  ) : (
                    <div className="Logo">
                      <img src={header.oglogo} alt="" width={130} />
                    </div>
                  )}
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={() => {
                      onRequestClose({
                        postId: singlepostListinfo?.postInfo?.postId || singlepostId,
                        postSnapshot: singlepostListinfo,
                        commentsSnapshot: singlepostCommentList,
                      });
                      setIspostmodalOpen(false);
                      setSinglePostId("");
                      setInitialSlideIndex(0);
                    }}
                  />
                </div>

                <div className="row w-100 m-0">
                  <div
                    className={`${singlepostListinfo?.cntntTypCategory === "Text"
                      ? "d-none"
                      : "col-md-7"
                      } p-0`}
                  >
                    <div className="image-slider-modal commentSection text-center">
                      {imageArray?.length > 1 ? (
                        <Slider initialSlide={initialSlideIndex}>
                          {singlepostListinfo?.postInfo?.mediaFilesList?.map(
                            (image, index) => (
                              <div key={index}>
                                <img
                                  src={image.mediaName}
                                  alt={`Slide ${index}`}
                                  className="img-fluid m-auto modal-image"
                                  onLoad={handleImageLoad} // Call handleImageLoad when image loads
                                />
                              </div>
                            )
                          )}
                        </Slider>
                      ) : (
                        <>
                          {singlepostListinfo?.cntntTypCategory !==
                            "TextWithVideo" &&
                            singlepostListinfo?.cntntTypCategory !== "Video" ? (
                            <img
                              src={
                                singlepostListinfo?.postInfo?.mediaFilesList?.[0]
                                  ?.mediaName
                              }
                              alt=""
                              className="img-fluid"
                              width="100%"
                            />
                          ) : null}

                          {(singlepostListinfo?.cntntTypCategory ===
                            "TextWithVideo" ||
                            singlepostListinfo?.cntntTypCategory === "Video") &&
                            singlepostListinfo?.postInfo?.mediaFilesList?.[0]
                              ?.mediaInfo ? (
                            <div

                              style={{
                                paddingBottom: "50px",
                                // width: "100%",
                                // maxWidth: "100%",
                                // aspectRatio: "16 / 9", //
                              }}>
                              <PostVideoCommon
                                file={singlepostListinfo?.postInfo?.mediaFilesList?.[0]}
                                item={singlepostListinfo}
                                restrictedViewerToken={restrictedViewerTokens}
                                setActiveVideoId={setActiveVideoId}
                                activeVideoId={activeVideoId}
                                AllPostList={AllPostList}
                                setPostList={setPostList}
                                visibleVideoRef={visibleVideoRef} />
                            </div>
                          ) :
                            <>
                              {/* START OF ADDED SHARE CONTENT BLOCK */}
                              <PostComponent item={singlepostListinfo} restrictedViewerToken={restrictedViewerTokens} isOpen={isOpen} isModalView={true} />
                            </>
                          }
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    className={`${singlepostListinfo?.cntntTypCategory === "Text"
                      ? "col-md-12"
                      : "col-md-5"
                      } p-0 ModifyScrollBar`}
                  // className={` ${Array.isArray(singlepostListinfo?.postInfo?.mediaFilesList) ||
                  //   singlepostListinfo?.postInfo?.mediaFilesList?.length === 0
                  //   ? "col-md-4"
                  //   : "col-md-12"
                  //   } p-0`}
                  >
                    <div className="featured-card user-postOnlyContent p-2 m-2">
                      <div className="feature-content p-2 d-flex justify-content-between">
                        <Link to={singlepostListinfo?.postInfo?.postOriginType === "Company" ? `/Company/${singlepostListinfo?.postInfo?.userUid}` : `/User/${singlepostListinfo?.postInfo?.userUid}`}>
                          <div className="d-flex align-items-center">
                            <div className="ImgAvatar">
                              <img
                                src={singlepostListinfo?.postInfo?.userAvatar}
                                alt=""
                                style={{ borderRadius: "50px" }}
                              />
                            </div>
                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {singlepostListinfo?.postInfo?.userName}
                              </h4>
                              {/* <p className="f-12">
                                  {moment
                                    .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                    .local()
                                    .format("DD MMMM YYYY [at] h:mm a")}
                                </p> */}
                              {language === "ar" ? (
                                <Tooltip title={moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .locale(locale)
                                  .local()
                                  .format("D MMMM YYYY [الساعة] h:mm a")} arrow>
                                  <p className="f-10 label">
                                    {moment
                                      .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                      .locale(locale)
                                      .local()
                                      .format("D MMMM YYYY [الساعة] h:mm a")}
                                  </p>
                                </Tooltip>
                              ) : (
                                <Tooltip title={moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .local()
                                  .format(language === "en"
                                    ? "D MMMM YYYY [at] h:mm a"
                                    : "D MMMM YYYY [को] h:mm a")} arrow>
                                  <p className="f-10 label">
                                    {getRelativeTime(singlepostListinfo)}</p>
                                </Tooltip>


                              )}

                            </div>
                          </div>
                        </Link>
                        {guestModeData === "true" ? null : (
                          <div className="row">
                            <div>
                              <SinglePostInteraction
                                postId={singlepostListinfo?.postInfo?.postId}
                                AllPostComments={AllPostComments}
                                AllPostList={AllPostList}
                                singlepostList={singlepostListinfo?.postInfo}
                                singlepostListData={singlepostListinfo}
                                AllPostListNews={AllPostListNews}
                                setSinglePostList={setSinglePostList}
                                PostOriginType={"User"}
                                postOriginId={userUid}
                                isfollowedComp={isfollowedComp}
                                setIsfollowedComp={setIsfollowedComp}
                                setIsConnected={setIsConnected}
                                isConnected={isConnected}
                                isfollowed={isfollowed}
                                setIsfollowed={setIsfollowed}
                                setPostList={setPostList}
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      {singlepostListinfo?.postInfo?.postContent && (
                        <div className="f-14 p-2 postContent">
                          <>
                            {!expandedPosts?.[singlepostListinfo?.postInfo?.postId] && (
                              <div
                                className="postContentDiv"
                                dangerouslySetInnerHTML={{
                                  __html: formattedContent,
                                }}
                              />
                            )}

                            {!expandedPosts?.[singlepostListinfo?.postInfo?.postId] &&
                              singlepostListinfo?.postInfo?.readMore && (
                                <span style={{ color: "#1051b0" }}
                                  onClick={() => readMore(singlepostListinfo?.postInfo?.postId)}
                                  className="pointer"
                                >
                                  {t("Newsfeed.Read More")}
                                </span>
                              )}

                            {expandedPosts?.[singlepostListinfo?.postInfo?.postId] &&
                              postContentMap?.[singlepostListinfo?.postInfo?.postId] && (
                                <div
                                  className="postContentDiv f-14"
                                  dangerouslySetInnerHTML={{
                                    __html: processExpandedContent(
                                      postContentMap[singlepostListinfo?.postInfo?.postId],
                                      singlepostListinfo?.postInfo?.dynamicValues
                                    ),
                                  }}
                                />
                              )}

                            {expandedPosts?.[singlepostListinfo?.postInfo?.postId] && (
                              <span style={{ color: "#1051b0" }}
                                className="pointer"
                                onClick={() =>
                                  setExpandedPosts((prev) => ({
                                    ...prev,
                                    [singlepostListinfo?.postInfo?.postId]: false,
                                  }))
                                }
                              >
                                {t("Newsfeed.Read Less")}
                              </span>
                            )}
                          </>
                        </div>
                      )}


                      <div className="feed-post p-2">
                        {guestModeData === "true" ? null : (
                          <div className="row">
                            <div className="addComment">
                              <SinglePostComment
                                isOwnedPost={singlepostListinfo?.postInfo?.isOwned}
                                postId={singlepostListinfo?.postInfo?.postId}
                                AllPostList={AllPostList}
                                singlepostList={singlepostList}
                                setSinglePostList={setSinglePostList}
                                AllPostComments={AllPostComments}
                                ispostmodalOpen={ispostmodalOpen}
                                setIspostmodalOpen={setIspostmodalOpen}
                                setPostList={setPostList}
                                setSinglePostCommentList={setSinglePostCommentList}
                                singlepostCommentList={singlepostCommentList}
                                videoRef={videoRef}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className={`postData d-flex align-items-center justify-content-between ${singlepostListinfo?.postInfo?.likeCount === 0 &&
                          singlepostListinfo?.commentCount === 0 &&
                          singlepostList?.postInfo?.postInfo?.shareCount === 0
                          ? ""
                          : "border-custom1"
                          }`}
                        style={{
                          direction: language === "ar" ? "rtl" : "ltr",
                          textAlign: language === "ar" ? "right" : "left",
                        }}
                      >
                        <div className="ms-2">
                          {singlepostListinfo?.postInfo?.likeCount === 0 || singlepostListinfo?.postInfo?.likeCount === null ? (
                            ""
                          ) : (
                            <p
                              className="f-10 pointer like-details"
                              onClick={() => handleShowModal(singlepostListinfo)}
                            >
                              {singlepostListinfo?.postInfo?.likeCount} <ThumbUpOutlinedIcon style={{ color: "#00419f", fontSize: "13px" }} />
                              {/* {t("Newsfeed.Like")} */}
                            </p>
                          )}
                        </div>
                        <div className=" d-flex">
                          {singlepostListinfo?.postInfo?.commentCount === 0 || singlepostListinfo?.postInfo?.commentCount === null ? (
                            ""
                          ) : (
                            <p className="f-10 me-2 pointer like-details">
                              {(singlepostCommentList?.length ?? singlepostListinfo?.postInfo?.commentCount ?? 0)} <ChatOutlinedIcon
                                style={{ color: "#00419f", fontSize: "13px" }} />
                              {/* {t("Newsfeed.Comment")} */}
                            </p>
                          )}

                          <p className="f-10">
                            {singlepostListinfo?.postInfo?.shareCount === 0 || singlepostListinfo?.postInfo?.shareCount === null
                              ? ""
                              : `& ${singlepostListinfo?.postInfo?.shareCount} ${t("Newsfeed.Share")}`}
                          </p>
                        </div>
                      </div>
                      <div className="postengagement">
                        <SinglePostEngagement
                          setIsLiked={setIsLiked}
                          isLiked={isLiked}
                          isOwnedPost={singlepostListinfo?.postInfo?.isOwned}
                          AllPostComments={AllPostComments}
                          updateCommentCount={updateCommentCount}
                          postId={singlepostListinfo?.postInfo?.postId}
                          AllPostList={AllPostList}
                          AllPostData={AllPostData}
                          postList={postList}
                          singlepostListinfo={singlepostListinfo}
                          setSinglePostListInfo={setSinglePostListInfo}
                          singlepostList={singlepostList}
                          setSinglePostList={setSinglePostList}
                          ispostmodalOpen={ispostmodalOpen}
                          setIspostmodalOpen={setIspostmodalOpen}
                          openModal={openModal}
                          setSinglePostId={setSinglePostId}
                          setSinglePostContent={setSinglePostContent}
                          setDLike={setDLike}
                          updateLikeCount={updateLikeCount}
                          setPostList={setPostList}
                          setSinglePostCommentList={setSinglePostCommentList}
                          singlepostCommentList={singlepostCommentList}
                          updateCommentLike={updateCommentLike}
                          updatePostLike={updatePostLike}
                          updateReplyCommentLike={updateReplyCommentLike}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {/* )} */}

      {/* {showModal && ( */}
      <LikesDetails
        showModal={showModal}
        handleLikesCloseModal={handleLikesCloseModal}
        postId={singlepostListinfo?.postInfo?.postId}
        postLikedType={postLikedType}
      />
      {/* )} */}
    </>
  );
};

export default ImageSliderModal;